/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
} from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

import { ItemExternalUPCInsertModel } from "../model/models";
import { ItemExternalUPCModel } from "../model/models";
import { ItemExternalUPCResponseModel } from "../model/models";
import { ItemExternalUPCUpdateModel } from "../model/models";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

export interface ApiItemexternalupcAllGetRequestParams {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiItemexternalupcDeleteIdDeleteRequestParams {
  id: number;
}

export interface ApiItemexternalupcIdGetRequestParams {
  id: number;
}

export interface ApiItemexternalupcInsertPostRequestParams {
  itemExternalUPCInsertModel?: ItemExternalUPCInsertModel;
}

export interface ApiItemexternalupcScanBarcodeBarcodeGetRequestParams {
  barcode: string;
}

export interface ApiItemexternalupcUpdatePutRequestParams {
  itemExternalUPCUpdateModel?: ItemExternalUPCUpdateModel;
}

@Injectable({
  providedIn: "root",
})
export class ItemExternalUPCService {
  protected basePath = "";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string,
  ): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string,
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substr(0, 10),
          );
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Get All List Item External UPC with pagination
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcAllGet(
    requestParameters: ApiItemexternalupcAllGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<ItemExternalUPCResponseModel>>;
  public apiItemexternalupcAllGet(
    requestParameters: ApiItemexternalupcAllGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<ItemExternalUPCResponseModel>>>;
  public apiItemexternalupcAllGet(
    requestParameters: ApiItemexternalupcAllGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<ItemExternalUPCResponseModel>>>;
  public apiItemexternalupcAllGet(
    requestParameters: ApiItemexternalupcAllGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<ItemExternalUPCResponseModel>>(
      `${this.configuration.basePath}/api/itemexternalupc/all`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Delete Item External UPC
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcDeleteIdDelete(
    requestParameters: ApiItemexternalupcDeleteIdDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiItemexternalupcDeleteIdDelete(
    requestParameters: ApiItemexternalupcDeleteIdDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiItemexternalupcDeleteIdDelete(
    requestParameters: ApiItemexternalupcDeleteIdDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiItemexternalupcDeleteIdDelete(
    requestParameters: ApiItemexternalupcDeleteIdDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiItemexternalupcDeleteIdDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<any>(
      `${
        this.configuration.basePath
      }/api/itemexternalupc/Delete/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All Item External UPC
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcGet(
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<ItemExternalUPCModel>>;
  public apiItemexternalupcGet(
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<ItemExternalUPCModel>>>;
  public apiItemexternalupcGet(
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<ItemExternalUPCModel>>>;
  public apiItemexternalupcGet(
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<ItemExternalUPCModel>>(
      `${this.configuration.basePath}/api/itemexternalupc`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Item External UPC by Id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcIdGet(
    requestParameters: ApiItemexternalupcIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ItemExternalUPCModel>;
  public apiItemexternalupcIdGet(
    requestParameters: ApiItemexternalupcIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ItemExternalUPCModel>>;
  public apiItemexternalupcIdGet(
    requestParameters: ApiItemexternalupcIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ItemExternalUPCModel>>;
  public apiItemexternalupcIdGet(
    requestParameters: ApiItemexternalupcIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiItemexternalupcIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ItemExternalUPCModel>(
      `${this.configuration.basePath}/api/itemexternalupc/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Insert Item External UPC
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcInsertPost(
    requestParameters: ApiItemexternalupcInsertPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiItemexternalupcInsertPost(
    requestParameters: ApiItemexternalupcInsertPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiItemexternalupcInsertPost(
    requestParameters: ApiItemexternalupcInsertPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiItemexternalupcInsertPost(
    requestParameters: ApiItemexternalupcInsertPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const itemExternalUPCInsertModel =
      requestParameters.itemExternalUPCInsertModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/itemexternalupc/Insert`,
      itemExternalUPCInsertModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Barcode Scan
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcScanBarcodeBarcodeGet(
    requestParameters: ApiItemexternalupcScanBarcodeBarcodeGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiItemexternalupcScanBarcodeBarcodeGet(
    requestParameters: ApiItemexternalupcScanBarcodeBarcodeGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiItemexternalupcScanBarcodeBarcodeGet(
    requestParameters: ApiItemexternalupcScanBarcodeBarcodeGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiItemexternalupcScanBarcodeBarcodeGet(
    requestParameters: ApiItemexternalupcScanBarcodeBarcodeGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const barcode = requestParameters.barcode;
    if (barcode === null || barcode === undefined) {
      throw new Error(
        "Required parameter barcode was null or undefined when calling apiItemexternalupcScanBarcodeBarcodeGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<any>(
      `${
        this.configuration.basePath
      }/api/itemexternalupc/scanBarcode/${encodeURIComponent(String(barcode))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Update Item External UPC
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiItemexternalupcUpdatePut(
    requestParameters: ApiItemexternalupcUpdatePutRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiItemexternalupcUpdatePut(
    requestParameters: ApiItemexternalupcUpdatePutRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiItemexternalupcUpdatePut(
    requestParameters: ApiItemexternalupcUpdatePutRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiItemexternalupcUpdatePut(
    requestParameters: ApiItemexternalupcUpdatePutRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const itemExternalUPCUpdateModel =
      requestParameters.itemExternalUPCUpdateModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/api/itemexternalupc/Update`,
      itemExternalUPCUpdateModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
